import React, { useEffect, useState } from "react";
import api from "@/utils/api";

const ago = (n) => (n <= 0 ? "due today" : `${n} day${n > 1 ? "s" : ""} late`);

/** Banner for staff/admin: NDD (next-day) shipments booked before today that are still not delivered. */
export default function NddWatchBanner({ active, onToggle }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let live = true;
    const load = () => api.get("/v2/ndd-watch").then((r) => { if (live) setD(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { live = false; clearInterval(t); };
  }, []);

  if (!d || d.total === 0) return null;
  return (
    <div className="rounded-lg border border-red-300 bg-red-50 p-3" data-testid="ndd-watch-banner">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm font-bold text-red-800">
          ⚠ {d.total} Next-Day shipment{d.total > 1 ? "s" : ""} not delivered yet
        </span>
        <span className="text-xs text-red-700">
          {d.overdue > 0 && <b>{d.overdue} overdue</b>}{d.overdue > 0 && d.due_today > 0 && " · "}{d.due_today > 0 && <b>{d.due_today} due today</b>}
          {" · "}{d.own_network} own network · {d.three_pl} 3PL
        </span>
        <div className="ml-auto flex gap-2">
          <button onClick={() => setOpen(!open)} className="text-xs font-semibold px-2.5 py-1 rounded border border-red-300 text-red-800 bg-white hover:bg-red-100" data-testid="ndd-watch-toggle-list">
            {open ? "Hide list" : "View list"}
          </button>
          <button onClick={onToggle} className={`text-xs font-semibold px-2.5 py-1 rounded ${active ? "bg-red-700 text-white" : "bg-red-600 text-white hover:bg-red-700"}`} data-testid="ndd-watch-filter">
            {active ? "Show all shipments" : "Show only these"}
          </button>
        </div>
      </div>
      {open && (
        <div className="mt-3 max-h-64 overflow-auto bg-white rounded border border-red-200">
          <table className="w-full text-xs">
            <thead className="bg-red-100 text-red-900">
              <tr><th className="text-left p-2">Order</th><th className="text-left p-2">LR/AWB</th><th className="text-left p-2">Route</th><th className="text-left p-2">Network</th><th className="text-left p-2">Status</th><th className="text-left p-2">Delay</th></tr>
            </thead>
            <tbody>
              {d.items.map((r) => (
                <tr key={r.id} className="border-t border-red-100">
                  <td className="p-2 font-mono">{r.order_id}</td>
                  <td className="p-2 font-mono">{r.lr || "-"}</td>
                  <td className="p-2">{r.from || "-"} → {r.to || "-"}</td>
                  <td className="p-2">{String(r.carrier).replace(/_/g, " ")}</td>
                  <td className="p-2 capitalize">{String(r.status || "").replace(/_/g, " ")}</td>
                  <td className={`p-2 font-semibold ${r.state === "overdue" ? "text-red-700" : "text-amber-700"}`}>{ago(r.days_late)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
